import { FormattedMessage } from "react-intl";

export default function NthEdition({
  asset,
  className,
}: {
  asset: { edition: number | string };
  className?: string;
}) {
  const edition =
    typeof asset.edition === "number"
      ? asset.edition
      : parseInt(asset.edition, 10);

  // generally avoid "Nanth Edition" if backend data is unexpected (nulls were seen in packages)
  if (isNaN(edition) || edition <= 1) {
    return null;
  }

  return (
    <div className={className}>
      <FormattedMessage
        defaultMessage="{edition, selectordinal, one {#st} two {#nd} few {#rd} other {#th}} Edition"
        values={{ edition }}
      />
    </div>
  );
}
